import { render } from "./basetooltipinfo.vue?vue&type=template&id=2ea65196"
import script from "./basetooltipinfo.vue?vue&type=script&lang=js"
export * from "./basetooltipinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__